<template lang="pug">
  .tabla.sombra
    b-table.table-container(
      :fields="fields" :items="deliveries"
      responsive
    )
      template(#cell(store)="{item}")
        div {{ item.store? item.store.name : '-' }}
  </template>

<script>
export default {
  props: {
    deliveries: Array
  },
  data () {
    return {
      fields: [
        { label: 'Código', key: 'code' },
        { label: 'Tienda', key: 'store' },
        { label: 'Comuna', key: 'commune' },
        { label: 'Dirección', key: 'address' },
        { label: 'Cliente', key: 'customerName' }
      ]
    }
  }
}

</script>

  <style lang="scss">
  .tabla {
    padding: 0;
  }
  .sombra {
    box-shadow: 0px 1px 1px #00000029;
  }
  .btn-container {
    background-color: #FFFFFF;
    position: sticky;
    bottom: 0%;
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
  }
  .table-container {
    height: calc(500px - 38vw);
    min-height: 45vh;
  }
  </style>
